<template>
  <!-- 公告审批 -->
  <div class="detail">
    <ax-panel :noTitle="true">
      <van-cell
        title="姓名"
        :value="data.header.emplid_description"
      ></van-cell>
      <van-cell
        title="提交日期"
        :value="data.header.action_dt_ss"
      ></van-cell>
      <van-cell
        title="标题"
        :value="data.header.qh_descr200"
      ></van-cell>
      <van-cell style="border-bottom:none">
        <p class="title">申请说明</p>
      </van-cell>
      <p
        class="desc"
        style="margin-bottom:20px"
      >{{data.header.comments_long}}</p>
    </ax-panel>
    <!-- 申请附件 -->
    <ax-panel title="申请附件">
      <van-cell
        title="附件"
        v-if="attachment"
      >
        <ax-down
          v-for="(fileItem, index) in data.qh_hr_026_att_v"
          type="ssc"
          :data="{
            fileName: fileItem.filename
          }"
          :key="index"
        >
          <router-link
            slot="fileName"
            class="link_a"
            :to="{
              name: 'fileImg',
              query: {
                ...$route.query,
                attachsysfilename: fileItem.attachsysfilename, // 附件唯一名称
                emplid: data.header.emplid, // 员工编号
                action_dt_ss: data.header.action_dt_ss, // 提交时间
                effseq: data.header.effseq, // 生效序号
                path: $route.query.pageId
              }
            }"
          >{{ fileItem.filename}}</router-link>
          <a
            class="item_content_val link_a"
            slot="right"
          >
            <van-icon name="arrow" />
          </a>
        </ax-down>
      </van-cell>
    </ax-panel>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  props: ['data'],
  data() {
    return {
      attachment: false,
      src: ''
    };
  },
  watch: {
    data() {
      this.attachment = this.data.qh_hr_026_att_v.length > 0;
    }
  }
};
</script>
<style lang="scss" scoped>
.van-cell .van-cell__value {
  text-align: right;
  padding-right: 0.4rem;
}
.van-cell {
  border-bottom: 1px solid $border-color;
}
.base {
  border-bottom: none;
}
.van-cell__right-icon {
  // margin-left: -2.8rem;
  // float: right;
  position: absolute;
  right: 0.1rem;
}
.w100 .van-cell__title {
  width: 8rem;
}
.van-collapse-item__wrapper .van-collapse-item__content {
  color: rgba(0, 0, 0, 0.9);
}
.title {
  color: rgba(0, 0, 0, 0.3);
  // color: #000;
  font-size: 0.4rem;
  text-align: left;
  padding-left: 0.42667rem;
}
.item_content_val {
  min-height: 22px;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: inline-flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  justify-content: flex-end;
  word-break: break-all;
  .iconfont {
    color: #ccc;
    font-size: 16px;
  }
}
.desc {
  color: #ccc;
  padding-left: 25px;
  font-size: 0.35rem;
  text-align: left;
}
</style>